<template>
    <v-card class="px-4">
        <v-card-title class="headline pl-0 mb-2">Reverse Payment</v-card-title>

        <div v-for="detail in payment.details">
            <v-layout row>
                <v-text-field
                    class="mb-1"
                    type="number"
                    :label="detail.category"
                    ref="amount"
                    v-model="detail.amount"
                    :rules="[
                        (value) => amountRules.required(value),
                        (value) => amountRules.min(value),
                        () =>
                            !detail.amount ||
                            detail.amount <= +detail.maxAmount ||
                            'Amount can\'t be more than Payment Amount',
                    ]"
                    prefix="$"
                ></v-text-field
            ></v-layout>
        </div>
        <v-text-field
            label="Reason"
            v-model="reason"
            ref="reason"
            :rules="reasonRules"
        ></v-text-field>

        <v-card-actions class="mx-0 pb-3">
            <v-spacer></v-spacer>
            <v-btn color="default" dark class="mr-1" @click="closeDialog()"
                >Cancel</v-btn
            >
            <v-btn :loading="processing" color="success" @click="reverse()">
                reverse
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import moment from "moment";
import { sum } from "../../utils/helpers.js";

export default {
    props: {
        closeDialog: Function,
        payment: Object,
        details: Array,
        reloadPage: Function,
    },
    data() {
        return {
            processing: false,
            reason: "",

            confirmDialog: false,

            categories: new Map([
                ["TC", "Tuition"],
                ["TRNS", "Transportation"],
                ["LAPC", "Lapidus"],
                ["DDIN", "Dinner"],
            ]),

            today: new Date().toISOString().substr(0, 10),

            reasonRules: [(value) => !!value || "Reason Is Required"],

            amountRules: {
                required: (value) => !!value || "Amount is Required",
                min: (value) => {
                    return !value || value >= 0 || "Amount can't be negative";
                },
            },
        };
    },
    watch: {},
    computed: {},
    methods: {
        buildData() {
            return {
                paymentID: this.payment.paymentID,
                amount: sum(this.payment.details.map((d) => +d.amount)).toFixed(
                    2
                ),
                reason: this.reason,
                user: this.$store.state.authentication.user,
                categories: this.payment.details
                    .filter((p) => p.amount > 0)
                    .map((d) => ({
                        code: this.getCategoryCode(d.category),
                        amount: d.amount,
                    })),
            };
        },
        getCategoryCode(category) {
            var reverseMap = new Map();

            Array.from(this.categories.entries()).forEach(([value, key]) => {
                reverseMap.set(key, value);
            });

            return reverseMap.get(category)
                ? reverseMap.get(category)
                : category;
        },
        validate() {
            if (!this.payment.details.some((p) => p.amount > 0)) {
                this.$notify({
                    text: "The amount must be more than 0.",
                    group: "notification",
                    type: "error",
                });

                return false;
            }

            const validations = [this.$refs.reason.validate(true)];

            this.payment.details.forEach((d, index) => {
                validations.push(this.$refs.amount[index].validate(true));
            });

            return validations.every(Boolean);
        },
        async reverse() {
            if (!this.validate()) return;

            this.processing = true;

            try {
                const response = await this.$http.post(
                    "api/payments/voidPayment",
                    this.buildData()
                );

                this.closeDialog();

                this.processing = false;

                this.$notify({
                    text: "Payment Reversed",
                    group: "notification",
                    type: "success",
                });

                this.reloadPage();
            } catch (e) {
                this.processing = false;

                return;
            }
        },
        confirmScheduleCancellation() {
            this.confirmCancellationDialog = true;
        },
        formatDate(date) {
            return moment(date).format("L");
        },
    },
};
</script>
<style></style>
